// Shipping configuration
export const shippingConfig = {
  // Free shipping threshold (in Kč)
  freeShippingThreshold: 499,
};

